<template>
  <div>
    <b-row>
      <b-col md="8">
        <!-- <h3
          style="color : #2c8ef8 ; margin-bottom : 10px ; margin-left : 10px ;"
          class="header-style"
        >
          Credential
        </h3> -->
      </b-col>
      <b-col md="4">
        <div>
          <b-modal
            id="credentialEdit"
            title="Credential"
            size="md"
            centered
            hide-footer
            header-class="header-nipige-class"
          >
            <sauthmodel>
              <template v-slot:footer-button="data">
                <b-row class="mt-3">
                  <b-col md="4"> </b-col>
                  <b-col md="4">
                    <b-button
                      class="btn btn-block"
                      btn-color="primary"
                      @click="AuthToNext(data.data)"
                      >Update</b-button
                    >
                  </b-col>
                  <b-col md="4"></b-col>
                </b-row>
              </template>
            </sauthmodel>
          </b-modal>
          <b-button
            v-b-modal.credentialEdit
            class="main-navigation-button w-1 edit_button"
            variant="white"
            style="
              margin-left: auto;
              display: block;
              margin-top: -19px;
              margin-right: -14px;
            "
            btn-color="primary1"
          >
            <v-avatar class="ml-n2 mt-n1" size="35">
              <img src="img/Edit.png" />
            </v-avatar>
          </b-button>
        </div>
      </b-col>
    </b-row>
    <div class="ml-2 mt-2">
      <div class="my-content">
        <!-- <b-row style="margin-top: -69px;"> -->
        <b-row>
          <b-col md="6" style="margin-top: -60px">
            <h4>User Name :</h4>
          </b-col>
          <b-col md="4" style="margin-left: 124px; margin-top: -58px"
            ><h5 class="text-muted ml-n3">{{ authData.userName }}</h5></b-col
          >
        </b-row>
        <!-- //////////// -->
        <b-row style="margin-top: -5px" class="mt-n2">
          <b-col md="3" style="margin-top: -13px">
            <h4>Security Questions :</h4>
          </b-col>
          <b-col md="6"
            ><h5 class="text-muted ml-n4">
              {{
                authData1 && authData1.securityQuestions
                  ? authData1.securityQuestions.question
                  : ""
              }}
            </h5></b-col
          >
        </b-row>
        <b-row style="margin-top: -5px" class="mt-n2">
          <b-col md="3" style="margin-top: -13px">
            <h4>Security Answer :</h4>
          </b-col>
          <b-col md="6"
            ><h5 class="text-muted ml-n4">
              {{
                authData1 && authData1.securityQuestions
                  ? authData1.securityQuestions.answer
                  : ""
              }}
            </h5></b-col
          >
        </b-row>
      </div>
      <!-- Mobile view start -->
      <div class="mobile-responsive">
        <b-row>
          <h4 style="margin-top: -31px; font-size: 15px">
            User Name :
            <span class="text-muted" style="margin-left: 20px; font-size: 13px">{{
              authData.userName
            }}</span>
          </h4>
        </b-row>
        <b-row>
          <h4 style="margin-top: 0px">
            Security Questions :
            <span class="text-muted" style="margin-left: 10px">
              {{
                authData1 && authData1.securityQuestions
                  ? authData1.securityQuestions.question
                  : ""
              }}</span
            >
          </h4>
        </b-row>
        <b-row>
          <h4 style="margin-top: 4px">
            Security Answer :
            <span class="text-muted" style="margin-left: 10px">
              {{
                authData1 && authData1.securityQuestions
                  ? authData1.securityQuestions.answer
                  : ""
              }}</span
            >
          </h4>
        </b-row>
      </div>
      <!-- Mobile view end -->
    </div>
  </div>
</template>
<script>
import sauthmodel from "@/components/Partner/PartnerEdit/AuthenticationStepper";
import { mapGetters } from "vuex";
export default {
  props: ["authData"],
  components: {
    sauthmodel,
  },
  data() {
    return {
      authData1: "",
    };
  },
  computed: {
    ...mapGetters({ partnerAllData: "partner/GetPartnerData" }),
  },
  methods: {
    async AuthToNext(data) {
      if (data.securityQuestions.question) {
        data.securityQuestions = {
          answer: data.securityQuestions.answer,
          question: data.securityQuestions.question.value,
        };
      } else {
        data.securityQuestions = {
          answer: data.securityQuestions.answer,
          question: data.securityQuestions.question.value,
        };
      }
      let authenticationData = {
        phone: data.phone,
        email: data.email,
        userName: data.userName,
        securityQuestions: data.securityQuestions,
      };
      let payload = {
        id: this.partnerAllData._id,
        data: {
          authentication: authenticationData,
        },
      };
      await this.$store
        .dispatch("partner/updatePartner", payload)
        .then((result) => {
          this.authData1 = result.response.authentication;
          this.$swal({
            title: "Success",
            text: "Partner Edited successfully!",
            type: "success",
          });
          this.$root.$emit("bv::hide::modal", "credentialEdit", "#btnShow");
        })
        .catch((error) => {
          //
        });
    },
  },
  mounted() {
    //console.log("authData", this.authData);
  },
};
</script>
<style>
.text-style {
  font-family: 'Lato';
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 18px;
  /* or 138% */

  letter-spacing: 0.15px;

  color: rgba(143, 143, 143, 0.87);
}

[btn-color="primary1"] {
  outline: none !important;
  border-radius: 50%;
  height: 39px;
  width: 39px;
}

[btn-special="primary1"] {
  border-radius: 50%;
}

.header-nipige-class {
  background-color: #737cf4;
  border-radius: 10px 10px 0px 0px;
}

.modal-title {
  font-size: 20px;
  color: white;
  text-align: center;
  margin-left: 40%;
}
.modal-content {
  border-radius: 10px 10px 10px 10px;
}

.header-style {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
}
@media (max-width: 767px) {
  .my-content {
    display: none;
  }
}
@media (min-width: 767px) {
  .mobile-responsive {
    display: none;
  }
}
@media (max-width: 767px) {
  .edit_button {
    margin-top: -34px;
  }
}
</style>
